export const faqs = [
  {
    question: '爱液润滑液是否安全？有哪些安全认证？',
    answer: '爱液全线产品通过国家药监局医疗器械备案、ISO 13485医疗器械质量管理体系认证、欧盟CE认证及SGS皮肤刺激性测试。每一批次产品均经过严格质检，确保安全无忧。我们坚持"六无"标准：无对羟基苯甲酸酯、无石油基成分、无人工香精、无色素添加、无刺激性表面活性剂、无动物源性成分。'
  },
  {
    question: '爱液润滑液可以和避孕套一起使用吗？',
    answer: '爱液水基润滑液系列和天然植萃系列可以与乳胶避孕套安全兼容使用。硅基润滑液系列建议查看避孕套说明书确认兼容性，部分乳胶避孕套可能与硅基成分产生相互作用。我们建议在使用前仔细阅读产品说明。'
  },
  {
    question: '润滑液会引起过敏吗？如何测试？',
    answer: '爱液全线产品采用低致敏配方，通过皮肤刺激性测试。但每个人体质不同，建议首次使用前在手腕内侧或耳后进行小范围皮肤测试。取少量产品涂抹于测试区域，观察24小时，如无红肿、瘙痒等不适反应即可放心使用。如果您属于极度敏感体质，推荐选择爱液天然植萃系列。'
  },
  {
    question: '润滑液的保质期是多久？如何正确保存？',
    answer: '爱液全线产品保质期为3年（未开封）。开封后建议在12个月内使用完毕。保存方法：请置于阴凉干燥处，避免阳光直射和高温环境。天然植萃系列开封后建议冷藏保存（2-8°C），冷藏后使用体验更佳。请勿冷冻产品。'
  },
  {
    question: '一瓶润滑液可以使用多少次？',
    answer: '使用次数因产品类型和个人用量而异。以200ml水基润滑液为例，每次使用约3-5ml（硬币大小），大约可使用40-60次。硅基润滑液每次用量更少（约1-2ml），150ml装大约可使用75-150次。建议根据实际需要适量使用，不够再补充。'
  },
  {
    question: '爱液润滑液适合孕妇使用吗？',
    answer: '爱液天然植萃系列专为孕期和哺乳期女性设计，采用100%天然植物配方，无任何化学添加，温和安全。其他系列产品建议孕期女性在使用前咨询产科医生。我们始终将安全放在第一位，孕期是一个特殊而美好的时期，值得最温柔的呵护。'
  },
  {
    question: '如何辨别爱液正品？',
    answer: '每瓶爱液产品包装上均有唯一防伪二维码，扫描即可验证真伪。正品特征：1）包装精致无毛边，印刷清晰；2）瓶身激光刻印生产批号和有效期；3）产品质地均匀，无分层或异味；4）正品防伪码首次查询显示"正品"及查询时间。请认准爱液官方渠道购买，谨防假冒。'
  },
  {
    question: '爱液支持哪些购买渠道？',
    answer: '爱液官方销售渠道包括：官方网站直营、天猫官方旗舰店、京东官方旗舰店、小红书官方旗舰店。我们建议通过官方渠道购买，以确保产品正品品质和售后服务。关注官方渠道可获取最新优惠活动和新品信息。'
  }
];

export const brandMilestones = [
  { year: '2018', title: '品牌创立', description: '爱液品牌正式成立，秉承"科学私护，温柔以待"的品牌理念，致力于为中国消费者提供安全专业的私密护理产品。' },
  { year: '2019', title: '首款产品上市', description: '爱液水润亲肤润滑液正式上市，凭借优质配方和亲民价格迅速获得市场认可，首年销量突破50万瓶。' },
  { year: '2020', title: '获得国际认证', description: '通过ISO 13485医疗器械质量管理体系认证和欧盟CE认证，产品质量获得国际权威认可，为品牌走向国际市场奠定基础。' },
  { year: '2021', title: '产品线扩展', description: '推出硅基系列和天然植萃系列，形成完整的产品矩阵，满足不同消费者的多元化需求。同年建立品牌自营电商渠道。' },
  { year: '2022', title: '研发升级', description: '成立品牌私密健康研究院，引入三重玻尿酸科技、神经酰胺修护技术等前沿科研成果，产品配方全面升级迭代。' },
  { year: '2023', title: '行业领导品牌', description: '年销量突破300万瓶，服务超过200万消费者，连续两年位列天猫双十一润滑液品类销量前三，成为行业标杆品牌。' },
  { year: '2024', title: '品牌升级', description: '发布全新品牌视觉形象，推出修护滋养系列新品，启动"私密健康公益计划"，致力于提升全社会对私密健康的认知和重视。' }
];

export const trustBadges = [
  { icon: 'ri-shield-check-line', title: '官方正品保障', description: '品牌直营，100%正品承诺，每瓶可溯源验证' },
  { icon: 'ri-test-tube-line', title: '权威质检认证', description: '通过ISO 13485、欧盟CE、SGS等多项国际认证' },
  { icon: 'ri-plant-line', title: '天然安全配方', description: '坚持"六无"标准，不添加任何争议性成分' },
  { icon: 'ri-customer-service-2-line', title: '专业私护顾问', description: '专业客服团队提供一对一私密健康咨询服务' },
  { icon: 'ri-truck-line', title: '隐私极速配送', description: '隐私包装发货，全国顺丰包邮，最快次日送达' },
  { icon: 'ri-refresh-line', title: '无忧退换服务', description: '7天无理由退换，任何质量问题包退包换' }
];